import React from "react";
import { Box, Tooltip, Typography } from "@mui/material";

// One line each, cut off with "…"; the full text is in a tooltip (`tooltip` overrides it).
const Line = ({ text, tooltip, sx }) => (
  <Tooltip title={tooltip ?? text} placement="top" arrow enterDelay={400}>
    <Typography noWrap sx={sx}>
      {text}
    </Typography>
  </Tooltip>
);

// Who is asking: email, then their name and cost center as smaller lines.
// full_name and cost_center_id can each be null. `costCenterName` is looked up
// from the cost center list by the caller; while that list is still loading
// (`costCentersLoaded` false) an unresolved id is skipped rather than flashing
// "Unknown cost center".
const RequesterCell = ({ request, costCenterName, costCentersLoaded = true }) => {
  const { email, full_name: fullName, cost_center_id: costCenterId } = request;

  return (
    <Box sx={{ minWidth: 0, width: "100%", py: 0.5 }}>
      <Line text={email} sx={{ fontSize: "0.78rem", color: "#1a1a1a" }} />
      {fullName && <Line text={fullName} sx={{ fontSize: "0.72rem", color: "#555" }} />}
      {costCenterId &&
        (costCenterName ? (
          <Line text={costCenterName} tooltip={`Cost Center: ${costCenterName}`} sx={{ fontSize: "0.7rem", color: "#888" }} />
        ) : (
          costCentersLoaded && (
            <Typography sx={{ fontSize: "0.7rem", color: "#aaa", fontStyle: "italic" }}>Unknown cost center</Typography>
          )
        ))}
    </Box>
  );
};

export default RequesterCell;
